import { t } from 'ttag'

import gradekSvg from '@h2/assets/svg/illustrations/navianceElementary/gradek.svg'
import grade1Svg from '@h2/assets/svg/illustrations/navianceElementary/grade1.svg'
import grade2Svg from '@h2/assets/svg/illustrations/navianceElementary/grade2.svg'
import grade3Svg from '@h2/assets/svg/illustrations/navianceElementary/grade3.svg'
import grade4Svg from '@h2/assets/svg/illustrations/navianceElementary/grade4.svg'
import grade5Svg from '@h2/assets/svg/illustrations/navianceElementary/grade5.svg'
import iAmSpecialSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/g1-IAmSpecial.svg'
import makingDreamsSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/g1-MakingDreamsHappen.svg'
import letsGoShoppingSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/g2-LetsGoShopping.svg'
import whatPeopleDoSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/g2-WhatPeopleDoAllDay.svg'
import whenYouGrowSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/k-Whenyougrowup.svg'
import jobsAreImportantSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/g1-JobsareImportant.svg'
import differentSchoolsSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/g2-DifferentkindsOfSchools.svg'
import letsMakeGoalSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/g2-LetsMakeAGoal.svg'
import whatAmIGoodAtSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/k-WhatAmIGoodAt.svg'
import whyWeGoToSchoolSvg from '@h2/assets/svg/illustrations/navianceElementary/lessons/k-WhyDoWeGoToSchool.svg'

export const gradesToNames = [
  { id: 0, name: t`Kindergarten Lessons`, image: gradekSvg },
  { id: 1, name: t`First Grade Lessons`, image: grade1Svg },
  { id: 2, name: t`Second Grade Lessons`, image: grade2Svg },
  { id: 3, name: t`Third Grade Lessons`, image: grade3Svg },
  { id: 4, name: t`Fourth Grade Lessons`, image: grade4Svg },
  { id: 5, name: t`Fifth Grade Lessons`, image: grade5Svg },
  { id: 6, name: t`Sixth Grade Lessons` },
  { id: 7, name: t`Seventh Grade Lessons` },
  { id: 8, name: t`Eighth Grade Lessons` },
  { id: 9, name: t`Ninth Grade Lessons` },
  { id: 10, name: t`Tenth Grade Lessons` },
  { id: 11, name: t`Eleventh Grade Lessons` },
  { id: 12, name: t`Twelfth Grade Lessons` },
  { id: 13, name: t`Higher Ed Lessons` },
  { id: 14, name: t`Professional Development Lessons` }
]
export const earlyGoalImageMap = {
  'n4e-kg': gradekSvg,
  'n4e-g1': grade1Svg,
  'n4e-g2': grade2Svg,
  'n4e-g3': grade3Svg,
  'n4e-g4': grade4Svg,
  'n4e-g5': grade5Svg,
  'v-kg-1': gradekSvg,
  'v-g1-1': grade1Svg,
  'v-g2-1': grade2Svg,
  'v-g3-1': grade3Svg,
  'v-g4-1': grade4Svg,
  'v-g5-1': grade5Svg,
  'v-kg-2': gradekSvg,
  'v-g1-2': grade1Svg,
  'v-g2-2': grade2Svg,
  'v-g3-2': grade3Svg,
  'v-g4-2': grade4Svg,
  'v-g5-2': grade5Svg,
  'v-kg-3': gradekSvg,
  'v-g1-3': grade1Svg,
  'v-g2-3': grade2Svg,
  'v-g3-3': grade3Svg,
  'v-g4-3': grade4Svg,
  'v-g5-3': grade5Svg,
  'v-kg-4': gradekSvg,
  'v-g1-4': grade1Svg,
  'v-g2-4': grade2Svg,
  'v-g3-4': grade3Svg,
  'v-g4-4': grade4Svg,
  'v-g5-4': grade5Svg
}

export const earlyLessonImageMap = {
  'g1-IAmSpecial': iAmSpecialSvg,
  'g1-MakingDreamsHappen': makingDreamsSvg,
  'g2-LetsGoShopping': letsGoShoppingSvg,
  'g2-WhatPeopleDoAllDay': whatPeopleDoSvg,
  'k-Whenyougrowup': whenYouGrowSvg,
  'g1-JobsareImportant': jobsAreImportantSvg,
  'g2-DifferentkindsOfSchools': differentSchoolsSvg,
  'g2-LetsMakeAGoal': letsMakeGoalSvg,
  'k-WhatAmIGoodAt': whatAmIGoodAtSvg,
  'k-WhyDoWeGoToSchool': whyWeGoToSchoolSvg
}
